// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jXoKp3zRuu1Laodid1jx {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family-primary);
  font-weight: 400;
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 240px;
  height: 36px;
  text-align: center;
  color: white;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .jXoKp3zRuu1Laodid1jx {
    width: 180px;
    height: 32px;
  }
}
.YkNxJ_ZaaR3Jex0oSeBz {
  position: absolute;
  width: 240px;
  height: 36px;
  top: 0;
  transform: translateX(-50%);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .YkNxJ_ZaaR3Jex0oSeBz {
    width: 180px;
    height: 30px;
  }
}
.htPg7RNKo8CVlsGDm9Bu {
  position: absolute;
  width: 75%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
}
.VCJuUjYuzdmZ3e2jSXSh {
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  white-space: nowrap;
}
.Hd2EFbqMoIpcme_M12hQ {
  font-size: inherit;
  line-height: normal;
  padding-right: 5px;
}
._xQjHTTbQaBAQnfLJ05L {
  font-size: inherit;
  line-height: normal;
  color: #ffd700;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/tournaments/tabs/RankingTab/ActivePlayers/ActivePlayers.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,MAAM;EACN,2BAA2B;AAC7B;AACA;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  position: absolute;\n  top: -2px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 240px;\n  height: 36px;\n  text-align: center;\n  color: white;\n}\n@media (--campaign-mobile) {\n  .container {\n    width: 180px;\n    height: 32px;\n  }\n}\n.backgroundImage {\n  position: absolute;\n  width: 240px;\n  height: 36px;\n  top: 0;\n  transform: translateX(-50%);\n}\n@media (--campaign-mobile) {\n  .backgroundImage {\n    width: 180px;\n    height: 30px;\n  }\n}\n.textWrapper {\n  position: absolute;\n  width: 75%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  white-space: nowrap;\n}\n.styledAutoTextfit {\n  height: 80%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.label {\n  font-size: inherit;\n  line-height: normal;\n  padding-right: 5px;\n}\n.playerCount {\n  font-size: inherit;\n  line-height: normal;\n  color: #ffd700;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `jXoKp3zRuu1Laodid1jx`,
	"backgroundImage": `YkNxJ_ZaaR3Jex0oSeBz`,
	"textWrapper": `htPg7RNKo8CVlsGDm9Bu`,
	"styledAutoTextfit": `VCJuUjYuzdmZ3e2jSXSh`,
	"label": `Hd2EFbqMoIpcme_M12hQ`,
	"playerCount": `_xQjHTTbQaBAQnfLJ05L`
};
export default ___CSS_LOADER_EXPORT___;
